import {NgModule} from '@angular/core';
import {Routes, RouterModule} from '@angular/router';
import {AppDefaultLayoutComponent} from '../layout/app-default-layout/app-default-layout.component';

import {HomeComponent} from './home.component';

const routes: Routes = [
    {
        path: '',
        component: AppDefaultLayoutComponent,
        children: [{path: 'home', component: HomeComponent}],
    },
];

@NgModule({
    imports: [RouterModule.forChild(routes)],
    exports: [RouterModule],
})
export class HomeRoutingModule {}
